import { render, staticRenderFns } from "./StudentManagement.vue?vue&type=template&id=55983274&"
import script from "./StudentManagement.vue?vue&type=script&lang=js&"
export * from "./StudentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports